
<div class="black-inputs">
  <el-row>
    <el-col :span="10" :offset="1">
      <el-form ref="dataClientForm" :rules="rulesFormPart1" :model="dataClient" label-width="0px">
        <el-form-item class="civ">
          <el-radio-group v-model="dataClient.civ">
            <el-radio-button label="M."></el-radio-button>
            <el-radio-button label="Mme"></el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="clientPreFix" class="cPrefix">
          <el-input v-model="dataClient.clientPreFix" placeholder="Préfixe"></el-input>
        </el-form-item>
        <el-form-item prop="name">
          <el-input v-model="dataClient.name" placeholder="Nom*"></el-input>
        </el-form-item>
        <el-form-item prop="prenom">
          <el-input v-model="dataClient.prenom" placeholder="Prénom*"></el-input>
        </el-form-item>
        <el-form-item prop="email">
          <el-input v-model="dataClient.email" placeholder="e-mail*"></el-input>
        </el-form-item>
        <el-form-item prop="telPreFix" class="tel-prefix">
          <el-input v-model="dataClient.telPreFix" placeholder="+33"></el-input>
        </el-form-item>
        <el-form-item prop="tel" class="tel">
          <el-input v-model="dataClient.tel" placeholder="Téléphone*"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="dataClient.societe" placeholder="Société"></el-input>
        </el-form-item>
        <el-form-item class="checkbox-green" label-width="auto" label="Offres promotionnelles (rgpd) :">
          <div class="content">
            <el-checkbox v-model="dataClient.rgpdmail">E-mail</el-checkbox>
            <el-checkbox v-model="dataClient.rgpdsms">SMS</el-checkbox>
          </div>
        </el-form-item>
      </el-form>
    </el-col>
    <el-col :span="10" :offset="1">
      <el-form ref="dataClientForm2" :model="dataClient" label-width="0px">
        <el-form-item>
          <el-input v-model="dataClient.comment" :autosize="{ minRows: 3 }" type="textarea"
            placeholder="Ajouter un commentaire"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="tagsSelected" multiple placeholder="Attribuer un label à la séléction">
            <el-option v-for="t in getAllTags" :key="t.value" :label="t.text" :value="t.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <client-tag v-for="tag in tagsSelected" :key="tag" :idTag="tag" :deletable="true" :cid="cid"></client-tag>
        </el-form-item>
      </el-form>
      <div v-if="getAllResas" class="black-inputs screen-clients">
        <el-table ref="multipleTable" :data="getAllResas">
          <el-table-column prop="formatDate" label="Date" sortable="custom">
          </el-table-column>
          <el-table-column prop="hour" label="Heure" sortable="custom">
          </el-table-column>
          <el-table-column prop="nbCouvert" label="Couverts" sortable="custom">
          </el-table-column>
          <el-table-column>
            <template slot-scope="scope">
              <i class="el-icon-view icon-btn" @click="gotoResa(scope.row)"></i>
            </template>
          </el-table-column>
        </el-table>
        <div class="clients-panel-container" style="text-align: center;margin-top: 30px;">
          <el-pagination background small layout="prev, pager, next" :total="total" @current-change="current_change">
          </el-pagination>
        </div>
      </div>
    </el-col>
  </el-row>
  <el-row>
    <el-col :span="10" :offset="1">
      <el-button class="dark" type="primary" @click="closeDialog()">Annuler</el-button>
    </el-col>
    <el-col :span="10" :offset="1">
      <el-button type="primary" @click="validModifications()">Valider</el-button>
    </el-col>
  </el-row>
</div>
